import axiosInstance from 'services/axiosMiddleware';

// Updated function to accept category data
export async function getCourse(coursedata) {
  // console.log(posedata)
  try {
   
    const response = await axiosInstance.post('course/getCourse', coursedata);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
